module.exports = __webpack_public_path__ + "img/IMG_20160810_143215.d232f281.jpg";